import React, { useState, useEffect } from 'react';
import { connect } from "react-redux";

import { useFirstRender } from 'components/Hooks/UseFirstRenderHook';

import FormControlLabel from '@mui/material/FormControlLabel';
import Switch from '@mui/material/Switch';


import { patchFournisseurPreuveAchatObligatoire } from 'utils/posters';


const FournisseurPreuveAchatObligatoire = ({ fournisseurId, valeur, patchFournisseurPreuveAchatObligatoire }) => {

    const firstRender = useFirstRender();

    const [valeurCourante, setValeurCourante] = useState(valeur);

    const [saving, setSaving] = useState(false);


    React.useEffect(() => {

        const patch = async () => {

            setSaving(true);

            var result = await patchFournisseurPreuveAchatObligatoire({ id: fournisseurId, preuveAchatObligatoire: valeurCourante });

            setSaving(false);
        };

        if (!firstRender) {
            console.log("changement de valeur courante = ", valeurCourante);
            patch();
        }
        else {
            console.log("Init de valeur courante = ", valeurCourante);
        }

    }, [valeurCourante]);




    return (
        <FormControlLabel
            disabled={saving}
            control={
                <Switch
                    checked={valeurCourante}
                    onChange={e => setValeurCourante(!valeurCourante)}
                    value="Actif"
                    color="secondary"
                />
            }
            label="Preuve d'achat obligatoire : "
            labelPlacement="start"
        />
    );
};



const mapDispatchToProps = {
    patchFournisseurPreuveAchatObligatoire
};

export default connect(null, mapDispatchToProps)(FournisseurPreuveAchatObligatoire);